
import { Md5 } from './md5';
import { getStorage, setStorage } from './tools';

const { v4: uuidv4 } = require('uuid');

export function getDeviceId(){
	return getStorage("lvdid")||createDeviceId();
}

function createDeviceId() {
	let _did = uuidv4();
	setStorage('lvdid', _did)
	return _did;
}